import { useState } from "react";
import { Profile } from "@/hooks/useProfile";
import { PersonalPlansSection } from "../PersonalPlansSection";
import { TeacherPlansSection } from "../TeacherPlansSection";
import { RoutineShimmer } from "../../RoutineShimmer";

interface WorkoutPlansSectionProps {
  workoutPlans: any[];
  profile: Profile | null;
  openSection: string;
  setOpenSection: (section: string) => void;
  refetchWorkoutPlans: () => void;
  routines: any[];
  isLoading?: boolean;
}

export const WorkoutPlansSection = ({
  workoutPlans,
  profile,
  openSection,
  setOpenSection,
  refetchWorkoutPlans,
  routines,
  isLoading
}: WorkoutPlansSectionProps) => {
  const [showForm, setShowForm] = useState(false);

  if (isLoading) {
    return <RoutineShimmer />;
  }

  return (
    <div className="space-y-6">
      <PersonalPlansSection
        plans={workoutPlans}
        profile={profile}
        openSection={openSection}
        setOpenSection={setOpenSection}
        showForm={showForm}
        setShowForm={setShowForm}
        refetchPlans={refetchWorkoutPlans}
        routines={routines}
      />

      {(profile?.role === "profesor" || profile?.role === "manager") && (
        <TeacherPlansSection
          plans={workoutPlans}
          profile={profile}
          openSection={openSection}
          setOpenSection={setOpenSection}
          showForm={showForm}
          setShowForm={setShowForm}
          refetchPlans={refetchWorkoutPlans}
          routines={routines}
        />
      )}
    </div>
  );
};